import { wine_and_book } from "./product_wine_and_book"; // ID : 6
import { lux_chess_set } from "./product_lux_chess_set"; // ID : 7
import { tic_tac_toe } from "./product_tic_tac_toe"; // ID : 9
import { new_year_decoration_set } from "./product_new_year_decoration_set"; // ID : 11

export const _essential_products = [
  wine_and_book, 
  lux_chess_set, 
  tic_tac_toe,
  new_year_decoration_set
];

export const getEssentialProducts = () => {
  return _essential_products;
};
